module.exports = "/_next/static/images/banner_icon_book-deac7c31dae58286a8439cd8c3555927.svg";